import { render, staticRenderFns } from "./SummaryByChannel.vue?vue&type=template&id=33e682b2&scoped=true&"
import script from "./SummaryByChannel.vue?vue&type=script&lang=js&"
export * from "./SummaryByChannel.vue?vue&type=script&lang=js&"
import style0 from "./SummaryByChannel.vue?vue&type=style&index=0&id=33e682b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e682b2",
  null
  
)

export default component.exports